import { render, staticRenderFns } from "./RouteDestinationDetails.vue?vue&type=template&id=777f1172&scoped=true"
import script from "./RouteDestinationDetails.vue?vue&type=script&lang=ts"
export * from "./RouteDestinationDetails.vue?vue&type=script&lang=ts"
import style0 from "./RouteDestinationDetails.vue?vue&type=style&index=0&id=777f1172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f1172",
  null
  
)

export default component.exports